/**
 * Phone helpers for tel: links and display.
 * Normalization: strip spaces/parentheses/dashes; 00 → +; no auto country code.
 */

export function normalizePhoneForTel(raw: string | null | undefined): string {
  if (!raw || typeof raw !== 'string') return '';
  let s = raw.trim().replace(/[\s\-()]/g, '');
  if (s.startsWith('00')) s = '+' + s.slice(2);
  return s;
}

export function getTelHref(phone: string | null | undefined): string | null {
  const normalized = normalizePhoneForTel(phone);
  if (!normalized) return null;
  return `tel:${normalized}`;
}

export function openTel(phone: string | null | undefined): void {
  const href = getTelHref(phone);
  if (!href) return;
  window.location.href = href;
}
